function CollectorHelper(CollectorsArray = []) {
  let tempArray = CollectorsArray.map((item) => {
    return { customerId: item[0], username: item[1], name: item[2] };
  });

  return tempArray;
}
export default CollectorHelper;
